import React from 'react';
import './collectionImageSlider.css';
import '../../cards.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../Media/Image/index';
import { ILabel, ILink, IVideo } from '../../../../../utils/types/contentful';
import { Link } from '../../../Elements/Link';
import { Video } from '../../../Media';
import clsx from 'clsx';

export interface CollectionImageSliderProps {
  label: ILabel;
  upLabel: ILabel;
  video: IVideo;
  link: ILink;
  images: any;
  width?: string | number;
  anchorId?: string;
}

const DEFAULT_WIDTH = 2;
export const CollectionImageSlider = ({
  label,
  upLabel,
  images,
  video,
  link,
  width,
  anchorId,
}: CollectionImageSliderProps) => {
  return (
    <div
      className={`col-span-${width ||
        DEFAULT_WIDTH} h-full w-full relative cursor-pointer`}
      id={anchorId}
    >
      <Link {...link} className={'h-full'}>
        <div
          className={clsx(
            'relative flex flex-col',
            'w-full',
            +width === 1 ? 'md:h-72' : 'h-72',
            'lg:h-80'
          )}
        >
          {images?.items[0] && (
            <div className='h-full flex items-center flex-col justify-center w-full'>
              <Image
                {...images?.items[0]}
                width='100%'
                height='100%'
                objectFit='cover'
              />
            </div>
          )}
          {video && (
            <div className='h-full flex items-center flex-col justify-center w-full'>
              <Video {...video} width='100%' height='100%' />
            </div>
          )}
        </div>
        <div className='h-32 bottom-0 w-full'>
          {upLabel && (
            <div className='w-full mt-4'>
              <Label
                {...upLabel}
                transform='uppercase'
                color={{ classname: 'primary' }}
                size='lg'
                weight='bold'
              />
            </div>
          )}
          {label && (
            <div className='w-full mt-1'>
              <Label
                {...label}
                color={{ classname: 'primary' }}
                size='lg'
                weight='light'
              />
            </div>
          )}
          {link && (
            <div className='w-full mt-1'>
              <Link
                {...link}
                label={{ ...link.label, decoration: 'underline' }}
              />
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};
